import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

const CONTENT_WRAPPER_MAX_WIDTH = 400

export const LegalMentionRowContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S4};
  max-width: ${CONTENT_WRAPPER_MAX_WIDTH}px;
`
